import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";

export const getCoachesAvailabilityApi = createAsyncThunk(
  "coaches/getCoachesAvailability",
  async (params = {}, { rejectWithValue }) => {
    const { topicId, date } = params;
    if (!topicId || !date) {
      return rejectWithValue({
        success: false,
        message: "topicId and date are required",
      });
    }
    try {
      const response = await axios.get(`/coaches/availability`, {
        params: { topicId, date },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to fetch coaches availability",
      });
    }
  }
);
